import { decode } from 'he';

const BLOCK_END = /<\/(p|div|li|h[1-6]|blockquote)>/gi;
const BREAK = /<br\s*\/?>/gi;

/**
 * Rich text as plain text: a summary's "<p>…</p>" (sometimes entity-encoded
 * once or twice over, "&lt;p&gt;…") for lists, previews and captions.
 * One line by default; `paragraphs` keeps a blank line between paragraphs.
 */
export function plainText(raw?: string | null, { paragraphs = false } = {}): string {
  if (!raw) return '';
  let s = raw;
  for (let i = 0; i < 3; i++) {
    const next = decode(s);
    if (next === s) break;
    s = next;
  }
  s = s.replace(BREAK, paragraphs ? '\n' : ' ').replace(BLOCK_END, paragraphs ? '$&\n\n' : '$& ');
  // DOMParser builds an inert document: no scripts run, no images load.
  const { body } = new DOMParser().parseFromString(s, 'text/html');
  body.querySelectorAll('script, style').forEach((n) => n.remove());
  const text = body.textContent || '';
  if (!paragraphs) return text.replace(/\s+/g, ' ').trim();
  return text
    .replace(/[ \t\u00a0]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
